import React from 'react'
import { useSelector } from 'react-redux'
import CustomTab from '../../../../components/tab/CustomTab'
import CustomIcon from '../../../../components/CustomIcon'
import DeleteTabMenu from './DeleteTabMenu'

const PageStickyTabItem = ({ updateTab, tab, activeTab }) => {

  const loading = useSelector((state) => state.dynamicElements.editing.loading)


  const selectedGroup = useSelector((state) => (state.dynamicUi.pages.selectedGroup))
  const pageData = useSelector((state) => (state.dynamicUi.pages[selectedGroup].data))
  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage))

  const isVertical = pageData[selectedPage]?.is_vertical

  const showDeleteWhen = !!activeTab

  return (

    isVertical ?
      <div onClick={() => updateTab(tab)} className={`flex space-x-4 items-start flex-shrink-0${!tab?.id ? ' sticky left-0 z-10 bg-white' : ''}`}>

        {tab?.id ?
          <div
            className={`${activeTab === tab.id ? 'text-secondary-500 cursor-default' : 'text-dark cursor-pointer hover:opacity-80 bg-white'} m-1 relative`}>
            <div className="flex flex-col items-center w-[70px]">
              <img src={tab.image_url} alt="icon" className={`${activeTab === tab.id ? 'border-secondary-500 border-2' : 'border'} h-[70px] aspect-square object-cover aspect-1 rounded-sm overflow-hidden}`} />
              {!!tab.title && <div className="text-xs text-center mt-1.5 leading-none text-2-clamp font-medium">{tab.title}</div>}
            </div>

            {(showDeleteWhen && activeTab === tab.id) &&
              <div className="absolute top-3.5 -translate-y-1/2 right-1">
                {showDeleteWhen && <DeleteTabMenu />}

              </div>
            }


          </div> :
          <div
            className={`w-[70px] h-[70px] aspect-1 flex items-center justify-center m-1 rounded-sm ${activeTab === tab.id ? ' !bg-secondary-500 !text-white !border-secondary-500' : 'border-2 border-rand-300  border-dashed border-1 b cursor-pointer hover:bg-gray-100'}`}>
            <CustomIcon icon="add" /></div>}


      </div> :
      <CustomTab onClick={() => updateTab(tab)}
                 className={`py-1 relative rounded ${tab?.id ? 'w-44 m-1 px-2 flex justify-center items-center bg-neutral-light' : `${activeTab === tab.id ? ' !bg-secondary-500 !text-white !border-secondary-500' : ''} w-8 min-h-8 flex justify-center items-center cursor rounded border-dotted border-2 border-rand-200 m-1`}`}
                 image={tab.image_url ?
                   <img className="h-6 w-6" src={tab.image_url} alt={tab.title} /> : ''}
                 disabled={loading}
                 active={activeTab === tab.id} title={tab?.id ? '' : 'Add A New Tab'}>
        {tab.title ?? <CustomIcon icon="add" />}
        {(showDeleteWhen && activeTab === tab.id) &&
          <div className="absolute top-1/2 -translate-y-1/2 right-1.5">
            {showDeleteWhen && <DeleteTabMenu />}

          </div>
        }
      </CustomTab>

  )
}

export default PageStickyTabItem



